import React, { useRef, useState } from 'react';
import './homepage.sass';
import emailjs from '@emailjs/browser';
import BackImg from '../assets/bg-pattern-desktop.svg';
import DeskImg from '../assets/cover1.png';
import TabImg from '../assets/hero-mobile.jpg';
import Arrow from '../assets/icon-arrow.svg';
import Error from '../assets/icon-error.svg';

function Homepage() {
  const form = useRef();
  const [error, setError] = useState({ opacity: 0 });
  const [btnStatus, setBtnStatus] = useState(true);
  const [message, setMessage] = useState(''); // State for success/error message

  const checkMail = (event) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailInput = event.target.value;

    if (emailInput.match(pattern) || emailInput === '') {
      setError({ opacity: 0 });
      event.target.style.border = '1px solid #41B883';
      setBtnStatus(false);
    } else {
      setError({ opacity: 1 });
      event.target.style.border = '2px solid hsl(0, 93%, 68%)';
      setBtnStatus(true);
    }

    if (emailInput === '') {
      setBtnStatus(true);
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_lplhz78', // Replace with your service ID
        'template_27o2y9q', // Replace with your template ID
        form.current,
        "kAyrP4sQuSaOcc0ca",
      )
      .then(
        () => {
          setMessage('Thank you! Your email has been successfully submitted.');
          document.getElementById('mail').value = ''; // Clear the email input
          setBtnStatus(true); // Disable button again
        },
        (error) => {
          console.error('FAILED...', error.text);
          setMessage('Something went wrong. Please try again.');
        }
      );
  };

  return (
    <header>
      <div className="textcontent">
        <div className="text-area">
          <h1 style={{textAlign: 'center'}}>
            <span>WE'RE</span>
            <br /> COMING <br /> SOON
          </h1>
          <p style={{fontSize: 20}}>
            We're excited to share that Teststream.ai is coming live very soon! We're currently in a
            closed beta phase, but you can add your email below to stay up-to-date with
            announcements, and maybe even get exclusive beta access.
          </p>
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              placeholder="Email Address"
              id="mail"
              name="user_email"
              onInput={checkMail}
              required
            />
            <label htmlFor="mail" className="error" style={error}>
              Please provide a valid email
            </label>
            <div className="error-icon error" style={error}>
              <img src={Error} alt="" />
            </div>
            <button type="submit" disabled={btnStatus}>
              <img src={Arrow} alt="" />
            </button>
          </form>
          {/* Success or Error Message */}
          {message && <p className={`message ${btnStatus ? 'error-message' : 'success-message'}`}>{message}</p>}
        </div>
      </div>
      {/* <picture>
        <source media="(max-width: 1024px)" srcSet={TabImg} />
        <img src={DeskImg} alt="" />
      </picture> */}
    </header>
  );
}

export default Homepage;
